import { useState } from 'react';
import ReinforcerListV2 from './ReinforcerListV2';
import './ReinforcerSettingForm.scss';
import ReinforcerStyleSetting from '../../mysettings/settings/reinforcers/ReinforcerStyleSetting';
import { REINFORCER_STYLE_KEY } from '../../../constants/PlayPreferenceConstant';
import SimpleReinforcer from './simple-reinforcer/SimpleReinforcer';
import SoundEffectSetting from '../sound-effect-setting/SoundEffectSetting';
import SelectAllSettings from '../select-all/SelectAllSettings';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';

const defaultReinforcers = [61, 62, 67];
const defaultProps = {
  profile: {},
  terminologies: {},
  onChangeCallback: () => {},
};

export default function ReinforcerSettingForm(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { profile, terminologies, onChangeCallback } = mergedProps;
  const [internalReinforcerStyle, setInternalReinforcerStyle] = useState(profile.reinforcerStyle);
  const showReinforcerDetail = internalReinforcerStyle === REINFORCER_STYLE_KEY.animated;

  return (
    <div className='reinforcer-setting-form'>
      <div className='reinforcer-style-container'>
        <ReinforcerStyleSetting
          profile={profile}
          onChangeCallback={(newValue) => {
            setInternalReinforcerStyle(newValue);
            const value = { reinforcerStyle: newValue };
            if (newValue === REINFORCER_STYLE_KEY.animated && profile.reinforcers.length === 0) {
              value.reinforcers = [...defaultReinforcers];
              // eslint-disable-next-line no-param-reassign
              profile.reinforcers = [...defaultReinforcers];
            }
            onChangeCallback(value);
          }}
        />
        {showReinforcerDetail && (
          <SoundEffectSetting
            profile={profile}
            onChangeCallback={(newValue) => onChangeCallback({ reinforcerSound: newValue })}
            attributeName='reinforcerSound'
          />
        )}
      </div>
      {!showReinforcerDetail && internalReinforcerStyle === REINFORCER_STYLE_KEY.simple && (
        <SimpleReinforcer />
      )}
      {showReinforcerDetail && (
        <>
          <SelectAllSettings
            attributeName='reinforcers'
            defaultValue={[...defaultReinforcers]}
            profile={profile}
            terminologies={terminologies}
            onChangeCallback={(newValue) => onChangeCallback({ reinforcers: newValue })}
          />
          <ReinforcerListV2
            profile={profile}
            terminologies={terminologies}
            onChangeCallback={(newValue) => onChangeCallback({ reinforcers: newValue })}
          />
        </>
      )}
    </div>
  );
}
